import { Flex } from "@gravity-ui/uikit";
import { PageMeta, ScrollToAnchor } from "src/components";
import { appConfig } from "src/config";
import { Footer } from "src/widgets";

import {
  AdvantagesBlock,
  HowWeWork,
  MainBlock,
  ReviewsBlock,
  ContactsBlock,
  RatesBlock,
  SolutionBlock,
} from "./components";
import { DotHighlightBackground } from "./components";
import css from "./LandingPage.module.scss";
import { LandingPageHeader } from "./widgets";

export const LandingPage = () => {
  const title = `${appConfig.displayName} — Автоматизация интернет-магазина товаров с Poizon и Dewu`;
  const description =
    "Автоматическая загрузка товаров, цен и остатков с Poizon/Dewu. Интеграция с InSales, WooCommerce и любой CMS.";

  return (
    <Flex
      direction="column"
      justifyContent="center"
      alignItems="center"
      className={css.flexGap}
    >
      <ScrollToAnchor />
      <PageMeta
        title={title}
        description={description}
        path="/"
        jsonLd={{
          "@type": "Organization",
          name: appConfig.displayName,
          url: appConfig.url,
          logo: "https://storage.yandexcloud.net/poison-front/static/ogLogo.png",
          description,
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer service",
          },
        }}
      />
      <DotHighlightBackground>
        <LandingPageHeader />
        <MainBlock />
      </DotHighlightBackground>

      <AdvantagesBlock />
      <SolutionBlock />
      <RatesBlock />
      <HowWeWork />
      <ReviewsBlock />
      <ContactsBlock />
      <Footer />
    </Flex>
  );
};
